import { MY_ROUTES } from '@/router/routes.enum'

const helpMailToAddress = import.meta.env.VITE_MENU_HELP_ADDRESS
const myBaseUrl = import.meta.env.VITE_DOMAIN_MY
const showReservations = import.meta.env.VITE_FEATURES_RESERVATIONS === 'true'
const showAccountCredits = import.meta.env.VITE_FEATURES_ACCOUNT_CREDITS === 'true'

export function myUrl(path: string) {
  return `${myBaseUrl}${path}`
}

export enum SETTINGS {
  ABBREVIATION = 'business_abbreviation',
  ADDRESS = 'business_address',
  ALLOWED_DOMAINS = 'allowed_domains',
  CUSTOMER_SUPPORT_EMAIL = 'customer_support_email',
  CUSTOMER_SUPPORT_PHONE = 'customer_support_phone',
  CUSTOMER_SUPPORT_URL = 'customer_support_url',
  DOMAIN = 'domain_name',
  FERRY_SCHEDULE_URL = 'ferry_schedule_url',
  LOGO_URL = 'logo_url',
  NAME = 'business_name',
  PRIVACY_POLICY_URL = 'privacy_policy_url',
  TERMS_OF_SERVICE_URL = 'terms_of_service_url'
}

export const MAX_INDIVIDUAL_TICKETS = 8

export const ACCOUNT_CREDIT_TITLE = 'Account Credit'

export const MY_MENU_ITEMS: Array<MenuItem> = [
  {
    title: 'Orders',
    to: MY_ROUTES.ORDERS,
    icon: 'rectangle-list'
  },
  ...(showReservations
    ? [
        {
          title: 'Reservations',
          to: MY_ROUTES.RESERVATIONS,
          icon: 'calendar-check'
        }
      ]
    : []),
  {
    title: 'Trip Cards',
    to: MY_ROUTES.TRIP_CARDS,
    icon: 'cards-blank'
  },
  ...(showAccountCredits
    ? [
        {
          title: ACCOUNT_CREDIT_TITLE,
          to: MY_ROUTES.ACCOUNT_CREDIT,
          icon: 'circle-dollar'
        }
      ]
    : []),
  {
    title: 'Payment Methods',
    to: MY_ROUTES.PAYMENT_METHODS,
    icon: 'wallet'
  },
  {
    title: 'My Account',
    to: MY_ROUTES.ACCOUNT,
    icon: 'user'
  },
  {
    title: 'Password & Security',
    to: MY_ROUTES.SECURITY,
    icon: 'lock'
  },
  {
    title: 'Help',
    to: helpMailToAddress,
    external: true,
    showExternalIcon: false,
    icon: 'square-question'
  },
  {
    title: 'Sign Out',
    to: MY_ROUTES.SIGN_OUT,
    icon: 'arrow-right-from-bracket'
  }
]

export const TICKETS_MENU_ITEMS: Array<MenuItem> = [
  {
    title: 'Orders',
    to: myUrl('/orders'),
    external: true,
    showExternalIcon: false,
    icon: 'rectangle-list'
  },
  ...(showReservations
    ? [
        {
          title: 'Reservations',
          to: myUrl('/reservations'),
          external: true,
          showExternalIcon: false,
          icon: 'calendar-check'
        }
      ]
    : []),
  {
    title: 'Trip Cards',
    to: myUrl('/trip_cards'),
    external: true,
    showExternalIcon: false,
    icon: 'cards-blank'
  },
  {
    title: 'Payment Methods',
    to: myUrl('/payment_methods'),
    external: true,
    showExternalIcon: false,
    icon: 'wallet'
  },
  {
    title: 'My Account',
    to: myUrl('/account'),
    external: true,
    showExternalIcon: false,
    icon: 'user'
  },
  {
    title: 'Password & Security',
    to: myUrl('/security'),
    external: true,
    showExternalIcon: false,
    icon: 'lock'
  },
  {
    title: 'Help',
    to: helpMailToAddress,
    external: true,
    showExternalIcon: false,
    icon: 'square-question'
  },
  {
    title: 'Sign Out',
    to: myUrl(`/sign_out?redirect_to=${window.location}`),
    external: true,
    showExternalIcon: false,
    icon: 'arrow-right-from-bracket'
  }
]

export const AVAILABLE_CC_ICONS = [
  'visa',
  'mastercard',
  'amex',
  'discover',
  'diners',
  'unionpay',
  'jcb'
]

export const MAPPED_CC_NETWORKS: { [network: string]: string } = {
  amex: 'American Express',
  diners: 'Diners Club',
  unionpay: 'UnionPay',
  jcb: 'JCB'
}

export const MAPPED_CC_GENERIC_LOGO: { [network: string]: string } = {}

export function normalizeBrand(brand: string | undefined | null): string {
  return brand && brand !== 'unknown' ? brand : ''
}

export const enum SERVER_ERRORS {
  INACTIVE_CUSTOMER = 'inactive_customer',
  BROWSER_MISMATCH = 'browser_mismatch',
  EXPIRED_LINK = 'expired_link',
  PASSWORD_RESET_REQUIRED = 'password_reset_required'
}

export const TAILWIND_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
}

export const ORDER_STATUS = {
  INCOMPLETE: 'Incomplete',
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  REFUNDED: 'Refunded',
  PARTIALLY_REFUNDED: 'Partially Refunded'
}

export const PASSKEY_ERRORS = {
  INVALID_STATE: 'InvalidStateError',
  NOT_ALLOWED: 'NotAllowedError'
}
